import { appConfig } from 'config/customization';
import Device from 'constants/deviceSizes';

export default {
  activeText: {
    color: appConfig.colors.activeText,
    width: '100%'
  },
  inactiveText: {
    color: appConfig.colors.inactiveText,
    width: '100%'
  },
  icon: {
    paddingRight: 20,
    height: 25,
    [Device.mobile]: {
      height: 16,
      padding: '2px 10px 2px 5px'
    }
  },
  link: {
    textDecoration: 'none',
    outline: 'none'
  }
};
